export const indexName = process.env.CRT_ALGOLIA_SEARCH_INDEX_NAME;
export const appId = process.env.CRT_ALGOLIA_SEARCH_APP_ID;
export const apiKey = process.env.CRT_ALGOLIA_SEARCH_API_KEY;